import { Cookies } from 'react-cookie';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { authAPI } from '../../services/api';

import {
    LOGIN_USER,
    LOGOUT_USER,
    REGISTER_USER,
    VERIFY_EMAIL,
    FORGET_PASSWORD,
    RESET_PASSWORD,
} from './constants';

import {
    loginUserSuccess,
    loginUserFailed,
    registerUserSuccess,
    registerUserFailed,
    verifyEmailSuccess,
    verifyEmailFailed,
    forgetPasswordSuccess,
    forgetPasswordFailed,
    resetPasswordSuccess,
    resetPasswordFailed,
} from './actions';

const setSession = (user) => {
    const cookies = new Cookies();
    if (user) cookies.set('user', JSON.stringify(user), { path: '/' });
    else cookies.remove('user', { path: '/' });
};

function* login({ payload: { username, password } }) {
    try {
        const { data } = yield call(authAPI.login, username, password);
        if (data.status === 200) {
            setSession(data);
            yield put(loginUserSuccess(data));
        } else {
            yield put(loginUserFailed(data.error || 'Erro no login'));
            setSession(null);
        }
    } catch (error) {
        const msg = error.response?.data?.error || 'Erro ao conectar com o servidor';
        yield put(loginUserFailed(msg));
        setSession(null);
    }
}

function* register({ payload: { fullname, email, password } }) {
    try {
        const { data } = yield call(authAPI.register, fullname, email, password);
        if (data.needsVerification) {
            yield put(registerUserSuccess({ email: data.email }));
        } else {
            yield put(registerUserFailed('Resposta inesperada do servidor'));
        }
    } catch (error) {
        const msg = error.response?.data?.error || 'Erro ao registrar';
        yield put(registerUserFailed(msg));
    }
}

function* verifyEmailSaga({ payload: { email, code } }) {
    try {
        const { data } = yield call(authAPI.verifyEmail, email, code);
        if (data.status === 200 && data.token) {
            setSession(data);
            yield put(verifyEmailSuccess(data));
        } else {
            yield put(verifyEmailFailed(data.error || 'Erro na verificacao'));
        }
    } catch (error) {
        const msg = error.response?.data?.error || 'Codigo invalido ou expirado';
        yield put(verifyEmailFailed(msg));
    }
}

function* forgetPassword({ payload: { email } }) {
    try {
        const { data } = yield call(authAPI.forgotPassword, email);
        yield put(forgetPasswordSuccess(data.message || 'Codigo enviado para o email'));
    } catch (error) {
        const msg = error.response?.data?.error || 'Erro ao enviar codigo';
        yield put(forgetPasswordFailed(msg));
    }
}

function* resetPasswordSaga({ payload: { email, code, newPassword } }) {
    try {
        const { data } = yield call(authAPI.resetPassword, email, code, newPassword);
        yield put(resetPasswordSuccess(data.message || 'Senha alterada com sucesso'));
    } catch (error) {
        const msg = error.response?.data?.error || 'Erro ao redefinir senha';
        yield put(resetPasswordFailed(msg));
    }
}

function* logout({ payload: { history } }) {
    try {
        setSession(null);
        yield call(() => {
            history.push('/account/login');
        });
    } catch (error) {}
}

export function* watchLoginUser() {
    yield takeEvery(LOGIN_USER, login);
}

export function* watchLogoutUser() {
    yield takeEvery(LOGOUT_USER, logout);
}

export function* watchRegisterUser() {
    yield takeEvery(REGISTER_USER, register);
}

export function* watchVerifyEmail() {
    yield takeEvery(VERIFY_EMAIL, verifyEmailSaga);
}

export function* watchForgetPassword() {
    yield takeEvery(FORGET_PASSWORD, forgetPassword);
}

export function* watchResetPassword() {
    yield takeEvery(RESET_PASSWORD, resetPasswordSaga);
}

function* authSaga() {
    yield all([
        fork(watchLoginUser),
        fork(watchLogoutUser),
        fork(watchRegisterUser),
        fork(watchVerifyEmail),
        fork(watchForgetPassword),
        fork(watchResetPassword),
    ]);
}

export default authSaga;
